import type { GetWeeklySelectionsQuery, GetAvailableMealsQuery } from '@/types/api';

export const weeklySelectionKeys = {
  all: ['weekly-selections'] as const,
  selections: (params?: GetWeeklySelectionsQuery) =>
    [...weeklySelectionKeys.all, 'selections', params] as const,
  availableMeals: (params?: GetAvailableMealsQuery) =>
    [...weeklySelectionKeys.all, 'available-meals', params] as const,
};
